import { Button, ButtonProps, CircularProgress, Stack } from "@mui/material";
import { FC, useState } from "react";

interface ButtonLoadingProps extends ButtonProps {
  onClick: () => Promise<void>;
  onDone?: () => void;
  btnText: string | JSX.Element;
  loadingText?: string;
  btnIcon?: JSX.Element;
}

const ButtonLoading: FC<ButtonLoadingProps> = ({
  onClick,
  onDone,
  btnText,
  loadingText = "Loading...",
  btnIcon,
  className,
  ...rest
}) => {
  const [loading, setLoading] = useState(false);
  return (
    <Button
      {...rest}
      disabled={loading || rest.disabled}
      onClick={async () => {
        setLoading(true);
        await onClick();
        setLoading(false);
        onDone && onDone();
      }}
    >
      <Stack direction="row" gap={1} alignItems="center">
        {loading ? loadingText : btnText}
        {loading ? <CircularProgress size={16} color="inherit" /> : btnIcon}
      </Stack>
    </Button>
  );
};

export default ButtonLoading;
